import styled from "styled-components";

export const StyledCardSection = styled.div`
  .card-section {
    width: calc(100% - 2px);
    border: 1px solid #cfcfcf;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0px 4px 10px 0px rgba(62, 44, 90, 0.08);

    .title-box {
      width: calc(100% - 16px);
      height: 50px;
      border-bottom: 1px solid #cfcfcf;
      display: flex;
      align-items: center;
      padding-left: 16px;
      background-color: #fafafb;
      .wrap {
        display: flex;
        align-items: center;
        gap: 10px;
        & > svg {
          width: 22px;
          height: 22px;
        }
        & > p {
          color: #333;
          font-size: 18px;
          font-weight: 700;
        }
      }
    }
    .content-box {
      width: calc(100% - 60px);
      padding: 30px;
    }
  }
`;
